import { Component, OnInit } from '@angular/core';
import { FormTemplateComponent } from '../../core/component/form-template/form-template.component';
import { FormControl } from '@angular/forms';
import { ValidatorService } from '../../../core/service/app/validator.service';

@Component({
  selector: 'app-address-template',
  templateUrl: './address-template.component.html',
  styleUrls: ['./address-template.component.scss']
})
export class AddressTemplateComponent extends FormTemplateComponent implements OnInit {

  constructor(private validatorService: ValidatorService) {
    super();
  }

  ngOnInit() {
    this.init();
  }

  template() {
    this.form.addControl('postalCode', new FormControl('', [], [this.postalCodeAsync.bind(this)]));
    this.form.addControl('street', new FormControl(null));
    this.form.addControl('colony', new FormControl(null));
    this.form.addControl('estate', new FormControl(null));
    this.form.addControl('numInt', new FormControl(null));
    this.form.addControl('numExt', new FormControl(null));
    this.form.addControl('population', new FormControl(null));
    this.form.addControl('phone1', new FormControl(null));
    this.form.addControl('phone2', new FormControl(null));
  }

  postalCodeAsync(control: FormControl)
  {
    return this.validatorService.postalCode(control.value).then( data => {
      return data? null : {error: 'Codigo Postal Invalido.'}
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/form/template/address-template/address-template.component.ts